import { userProfiles } from "./user-profile"
export * from "./dolphins/interface"
export * from "./user-profile/interface"


export const models = {
  userProfiles,
}
